<template>
  <div class="form">
    <div class="form__content">
      <h1 class="extra-large-headline">
        Where would you like us to deposit your funds?
      </h1>
      <p>
        Enter the details of an bank account where you'd like us to deposit your
        funds. Make sure the account is a personal account in your name (no
        business accounts)
      </p>
    </div>
    <form @submit.prevent>
      <FormInputField
        name="accountName"
        label="Account Name*"
        placeholder="Enter name on your account"
        type="text"
        iconType="NameUserCircle"
        :inputValue="form.accountName"
        :errors="form.accountNameErrors"
        v-model:accountName="form.accountName"
      />
      <FormInputField
        name="bsbNumber"
        label="BSB Number*"
        placeholder="Enter BSB number"
        type="number"
        iconType="HashCircle"
        :inputValue="form.bsbNumber"
        :errors="form.bsbNumberErrors"
        v-model:bsbNumber="form.bsbNumber"
      />
      <FormInputField
        name="accountNumber"
        label="Account Number*"
        placeholder="Enter account nunber"
        type="number"
        iconType="HashCircle"
        iconColor="#00D6BF"
        :inputValue="form.accountNumber"
        :errors="form.accountNumberErrors"
        v-model:accountNumber="form.accountNumber"
      />
      <ButtonBase
        :isDisabled="store.formHasErrors || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        Continue
      </ButtonBase>
    </form>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useDepositFormStore } from "@/stores/forms/depositFormStore";

import baseFormValidators from "@/composables/validations/baseFormValidators.js";

import FormInputField from "@/components/ui/inputs/FormInputField.vue";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";

const { isEmpty } = baseFormValidators();
const router = useRouter();
const store = useDepositFormStore();
const globalStore = useGlobalStore();
const form = ref({
  accountName: store.form.accountName.value || "",
  accountNameErrors: store.form.accountName.error || "",
  bsbNumber: store.form.bsbNumber.value || "",
  bsbNumberErrors: store.form.bsbNumber.error || "",
  accountNumber: store.form.accountNumber.value || "",
  accountNumberErrors: store.form.accountNumber.error || "",
});

watch(
  () => form.value.accountName,
  (accountName) => {
    const accountNameErrors = isEmpty("account name", accountName);

    store.updateValue("accountName", accountName);
    store.updateError("accountName", accountNameErrors);

    form.value.accountNameErrors = accountNameErrors;
  }
);

watch(
  () => form.value.bsbNumber,
  (bsbNumber) => {
    const bsbNumberErrors = isEmpty("bsb number", bsbNumber);

    store.updateValue("bsbNumber", bsbNumber);
    store.updateError("bsbNumber", bsbNumberErrors);

    form.value.bsbNumberErrors = bsbNumberErrors;
  }
);

watch(
  () => form.value.accountNumber,
  (accountNumber) => {
    const accountNumberErrors = isEmpty("account number", accountNumber);

    store.updateValue("accountNumber", accountNumber);
    store.updateError("accountNumber", accountNumberErrors);

    form.value.accountNumberErrors = accountNumberErrors;
  }
);

const handleFormSubmit = () => {
  globalStore.setIsFormLoading(true);
  // Send the form data to the endpoint
  // Note: Timeout used for demonstration purposes:
  // setTimeout(() => {
  //   router.push("/verification");
  // }, 500);
};
</script>
